import React from 'react'
import TPABaseComponent from '../TpaCommon/TPABaseComponent'

const TPAMultiSection: typeof TPABaseComponent = (props) => {
	return <TPABaseComponent {...props} />
}

export default TPAMultiSection
